import React, { useEffect, useState } from "react"
import { MobergCheckbox, MobergColumn, MobergDropdown, MobergInputLabel, MobergNumberInput, MobergRow } from "../../../../../../../Moberg"
import { Analytic, MAPOptAnalysis } from "../../../Types/AnalysisDetails"
import { validateCOxThreshold } from "../../Visualizations/MAPOpt/validation"
import { useTraceOptions } from "./useTraceOptions"
import { equalsTraceOptionOrString } from "../../../utils"

type EditMAPOptProps = {
	initialState: MAPOptAnalysis
	onChange: (analysis: MAPOptAnalysis) => void
}

export const EditMAPOpt: React.FC<EditMAPOptProps> = ({ initialState, onChange }) => {
	const traceOptions = useTraceOptions()
	const [ABP, setABPModality] = useState<string>(initialState.ABP)
	const [stO2Left, setStO2Left] = useState<string>(initialState.stO2Left)
	const [stO2Right, setStO2Right] = useState<string>(initialState.stO2Right)
	const [enableLeft, setEnableLeft] = useState<boolean>(initialState.enableLeft)
	const [enableRight, setEnableRight] = useState<boolean>(initialState.enableRight)
	const [coxThreshold, setCOxThreshold] = useState<number>(initialState.coxThreshold)

	useEffect(() => {
		onChange({
			...initialState,
			analytic: Analytic.MAPOpt,
			ABP,
			stO2Left,
			stO2Right,
			enableLeft,
			enableRight,
			coxThreshold,
			calculationWindowMs: 4 * 60 * 60 * 1000,
			calculationPeriodMs: 60 * 1000
		})
	})

	return (
		<MobergColumn gap="16px">
			<MobergColumn gap="8px">
				<MobergInputLabel text={"ABP"} />

				<MobergDropdown
					options={traceOptions}
					onChange={newValue => setABPModality(newValue.rawDataKey)}
					selectedValue={ABP}
					equals={equalsTraceOptionOrString}
				/>
			</MobergColumn>

			<MobergRow gap="32px">
				<MobergColumn gap="8px">
					<MobergInputLabel text={"StO2 (left)"} />

					<MobergDropdown
						options={traceOptions}
						onChange={newValue => setStO2Left(newValue.rawDataKey)}
						selectedValue={stO2Left}
						equals={equalsTraceOptionOrString}
					/>
				</MobergColumn>

				<MobergColumn gap="8px">
					<MobergInputLabel text={"Enabled"} />
					<MobergCheckbox isChecked={enableLeft} onChange={setEnableLeft} />
				</MobergColumn>
			</MobergRow>

			<MobergRow gap="32px">
				<MobergColumn gap="8px">
					<MobergInputLabel text={"StO2 (right)"} />

					<MobergDropdown
						options={traceOptions}
						onChange={newValue => setStO2Right(newValue.rawDataKey)}
						selectedValue={stO2Right}
						equals={equalsTraceOptionOrString}
					/>
				</MobergColumn>

				<MobergColumn gap="8px">
					<MobergInputLabel text={"Enabled"} />
					<MobergCheckbox isChecked={enableRight} onChange={setEnableRight} />
				</MobergColumn>
			</MobergRow>

			<MobergColumn gap="8px">
				<MobergInputLabel text={"COx threshold for autoregulation"} />

				<MobergNumberInput
					defaultValue={0.3}
					value={coxThreshold}
					validationFunction={validateCOxThreshold}
					onChange={threshold => { setCOxThreshold(threshold as number) }}
				/>
			</MobergColumn>
		</MobergColumn>
	)
}
